import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, LIST } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_BILLING,
    StoreType,
    LoadBillingHistory,
    setBillingHistory,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import CurrentPackage from "./currentPackage"
import BillingHistory from "./history"
import SubscriptionButton from "./subscriptionButton"

const MtBilling = () => {
    const reloadbillingHistory = useSelector((state: StoreType) => state.billing.reloadBillingHistory)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadbillingHistory) return
        setLoadState(PENDING)
        LoadBillingHistory(userData.accountId).then((res) => {
            dispatch(setBillingHistory(res))
            setLoadState(IDLE)
        })
    }, [reloadbillingHistory])

    const listAccess = hasAccess(PRM_BILLING, LIST)

    if (userData.accountId === 1) return <AccessDenied /> // only for account holders
    if (!listAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.billing}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <CurrentPackage />

                <SubscriptionButton />

                <BillingHistory />
            </PageContent>

        </Container>
    )
}
export default MtBilling
